import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, ComponentPublicInstance } from "vue";
import UserDepartmentForm, {
  Department
} from "../content/UserDepartmentForm.vue";
import UserDepartmentDialog from "./UserDepartmentDialog.vue";
import { Messages } from "@/message";
import { useAlert } from "@/plugins/alert/alert";
import { UserDepartment } from "@/models/user-master/UserMasterRequest";
import { useApi } from "@/plugins/api/api";
import { UserMasterDepartment } from "@/models/user-master/UserMasterResponse";

type Props = {
  value: boolean;
  item?: UserMasterDepartment;
};
type Emits = {
  (e: "input", val: boolean): void;
  (e: "submit"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserDepartmentEdit',
  props: {
    value: { type: Boolean },
    item: null
  },
  emits: ["input", "submit"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  item?: UserMasterDepartment;
};

const { $put, Paths } = useApi();
const { $alert } = useAlert();




const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const form = ref<Department>();
const vform = ref<ComponentPublicInstance<typeof UserDepartmentForm>>();

const userId = computed(() => (props.item?.incode ? props.item.incode : NaN));

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", Messages.Form.Validate);
    return;
  }
  const request: UserDepartment = { incode: userId.value, ...form.value };
  const response = await $put(Paths.userMaster.departments.default, request);
  if (response) {
    modelValue.value = false;
    $alert("success", Messages.Success.Update);
    emits("submit");
  }
};

watch(
  () => props.item,
  val => {
    form.value = {
      affiliationId: val?.affiliationId,
      amount1: val?.amount1,
      amount2: val?.amount2,
      amount3: val?.amount3,
      subSpecialCommit: val?.subSpecialCommit
    };
  }
);

return { __sfc: true,$put, Paths, $alert, props, emits, modelValue, form, vform, userId, onSubmit, UserDepartmentForm, UserDepartmentDialog }
}

})